<template>
  <el-dialog center title="编辑详情信息" :visible.sync="dialogVisible" width="80%" :before-close="handleClose" :close-on-click-modal="false" class="custom-max-width-dialog">
    <el-form ref="detailForm" :model="formData" label-position="left" label-width="260px" class="detail-form">
      <el-tabs v-model="activeName" style="width: calc(100% - 20px);">
        <el-tab-pane label="基本信息" name="baseInfo">
          <h3>检查信息</h3>

          <div class="barcode-line">
            <el-form-item label="条码" label-width="150px" class="barcode-item">
              <el-input v-model="barcodeText" size="small" style="width: 230px" placeholder="扫码或手动输入条码" clearable />
              <el-button type="primary" size="small" :loading="queryLoading" icon="el-icon-search" @click="handleQueryByBarcode" style="margin-left: 10px;">查询</el-button>
              <el-button type="warning" size="small" icon="el-icon-camera" @click="openScanDialog" style="margin-left: 6px;" plain>扫码</el-button>
              <span v-if="queryError" class="query-error">{{ queryError }}</span>
            </el-form-item>
          </div>

          <div class="form-fields-wrapper">
            <div v-for="column in filteredTableBasicColumns" :key="column.prop" class="form-field-item">
              <el-form-item :label="column.label" :label-width="column.width || '150px'" :prop="column.prop" :rules="getFieldRules(column.prop)">
                <el-input v-if="isReadOnlyBasicField(column.prop)" v-model="formData[column.prop]" size="small" style="width: 150px" readonly disabled />
                <el-date-picker v-else-if="column.prop === 'birth_date' || column.prop === 'pre_diagnose_time'" v-model="formData[column.prop]" type="date" placeholder="选择日期" size="small" style="width: 150px" format="yyyy-MM-dd" value-format="yyyy-MM-dd" />
                <el-select v-else-if="isSelectField(column.prop)" v-model="formData[column.prop]" size="small" style="width: 150px" clearable>
                  <el-option v-for="(option, index) in getSelectOptions(column.prop)" :key="`${column.prop}-${index}`" :label="option" :value="getSelectValue(column.prop, option, index)" />
                </el-select>
                <el-input v-else v-model="formData[column.prop]" :placeholder="'请输入' + column.label" size="small" style="width: 150px" @input="handleBasicFieldChange(column.prop)" @focus="handleInputFocus(column.prop)" @blur="handleInputBlur(column.prop)" />
              </el-form-item>
            </div>
          </div>

          <h3>光环境情况</h3>
          <div class="form-fields-box">
            <div v-for="column in tableLightColumns" :key="column.prop" class="form-box-item">
              <el-form-item :label="column.label" :label-width="column.width || '135px'" :prop="column.prop">
                <el-select v-if="isSelectField(column.prop)" v-model="formData[column.prop]" size="small" style="width: 135px" clearable>
                  <el-option v-for="(option, index) in getSelectOptions(column.prop)" :key="`${column.prop}-${index}`" :label="option" :value="getSelectValue(column.prop, option, index)" />
                </el-select>
                <el-input v-else v-model="formData[column.prop]" :placeholder="'请输入' + column.label" size="small" style="width: 135px" />
              </el-form-item>
            </div>
          </div>

          <h3>行为习惯</h3>
          <div class="form-fields-box">
            <div v-for="column in tableBehaveColumns" :key="column.prop" class="form-box-item">
              <el-form-item :label="column.label" :label-width="column.width || '135px'" :prop="column.prop">
                <el-select v-if="isSelectField(column.prop)" v-model="formData[column.prop]" size="small" style="width: 135px" clearable>
                  <el-option v-for="(option, index) in getSelectOptions(column.prop)" :key="`${column.prop}-${index}`" :label="option" :value="getSelectValue(column.prop, option, index)" />
                </el-select>
                <el-input v-else v-model="formData[column.prop]" :placeholder="'请输入' + column.label" size="small" style="width: 135px" />
              </el-form-item>
            </div>
          </div>

          <h3>已采用防控手段</h3>
          <div style="margin-bottom: 10px; display: flex; flex-wrap: wrap; gap: 10px 10px; align-items: center;">
            <el-checkbox v-model="formData.e1" :true-label="1" :false-label="0" @change="handleCheckboxChange">红光</el-checkbox>
            <el-checkbox v-model="formData.e2" :true-label="1" :false-label="0" @change="handleCheckboxChange">视觉训练</el-checkbox>
            <el-checkbox v-model="formData.e3" :true-label="1" :false-label="0" @change="handleCheckboxChange">低浓度阿托品</el-checkbox>
            <el-checkbox v-model="formData.e4" :true-label="1" :false-label="0" @change="handleCheckboxChange">角塑</el-checkbox>
            <el-checkbox v-model="formData.e5" :true-label="1" :false-label="0" @change="handleCheckboxChange">框架眼镜</el-checkbox>
            <el-select v-model="formData.e5Type" size="small" style="width: 120px" :disabled="formData.e5 !== 1" placeholder="请选择类型">
              <el-option label="单光技术" :value="1" />
              <el-option label="离焦技术" :value="2" />
              <el-option label="DOT技术" :value="3" />
              <el-option label="双控技术" :value="4" />
            </el-select>
            <el-select v-model="formData.e5Time" size="small" style="width: 120px" :disabled="formData.e5 !== 1" placeholder="佩戴时间">
              <el-option label="3个月及以内" :value="1" />
              <el-option label="4-6个月" :value="2" />
              <el-option label="7-12个月" :value="3" />
              <el-option label="12个月以上" :value="4" />
            </el-select>
            <el-checkbox v-model="formData.e7" :true-label="1" :false-label="0" @change="handleCheckboxChange">其他</el-checkbox>
            <el-select v-model="formData.e7Type" size="small" style="width: 120px" :disabled="formData.e7 !== 1" placeholder="请选择类型">
              <el-option label="远像屏" :value="1" />
              <el-option label="拉远镜" :value="2" />
              <el-option label="读写台" :value="3" />
              <el-option label="大路灯/小路灯" :value="4" />
            </el-select>
            <el-checkbox v-model="formData.e6" :true-label="1" :false-label="0" @change="handleNoneCheckboxChange">无</el-checkbox>
          </div>
        </el-tab-pane>

        <el-tab-pane label="户外活动信息" name="outdoorInfo">
          <div class="array-form-section">
            <div v-for="(dayItem, dayIndex) in formData.outdoor || []" :key="dayIndex" class="array-item">
              <div class="array-item-header">
                <h4>{{ dayItem.check_date || `第${dayIndex + 1}天` }} 户外活动记录</h4>
                <el-button type="danger" size="mini" @click="removeOutdoorDayItem(dayIndex)">删除当天记录</el-button>
              </div>
              <div class="day-basic-info">
                <div class="form-field-item">
                  <el-form-item label="检查日期" label-width="80px" :prop="`outdoor.${dayIndex}.check_date`" :rules="[{ required: true, message: '请选择检查日期', trigger: 'change' }]">
                    <el-date-picker v-model="dayItem.check_date" type="date" placeholder="选择日期" size="small" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width: 100%"></el-date-picker>
                  </el-form-item>
                </div>
                <div class="form-field-item">
                  <el-form-item label="户外活动时长（分钟）" label-width="170px" :prop="`outdoor.${dayIndex}.f1`" :rules="[{ required: true, message: '请输入活动时长', trigger: 'blur' }]">
                    <el-input-number v-model="dayItem.f1" :min="0" :max="1440" size="small" style="width: 100%" placeholder="输入活动时长"></el-input-number>
                  </el-form-item>
                </div>
              </div>
              <div class="light-intensity-section">
                <div class="light-section-header">
                  <h5>光照强度记录</h5>
                  <el-button type="primary" size="mini" @click="addLightRecord(dayIndex)">添加光照记录</el-button>
                </div>
                <div v-if="dayItem.lightRecords && dayItem.lightRecords.length > 0" class="light-records">
                  <div v-for="(lightRecord, lightIndex) in dayItem.lightRecords" :key="lightIndex" class="light-record-item">
                    <div class="light-record-content">
                      <div class="form-field-item">
                        <el-form-item label="时间段" label-width="80px" :prop="`outdoor.${dayIndex}.lightRecords.${lightIndex}.hour_id`" :rules="[{ required: true, message: '请选择时间段', trigger: 'change' }]">
                          <el-select v-model="lightRecord.hour_id" size="small" style="width: 100%" placeholder="选择时间段">
                            <el-option v-for="hour in 24" :key="hour - 1" :label="`${hour - 1}:00-${hour}:00`" :value="hour - 1"></el-option>
                          </el-select>
                        </el-form-item>
                      </div>
                      <div class="form-field-item">
                        <el-form-item label="光照强度（lx）" label-width="120px" :prop="`outdoor.${dayIndex}.lightRecords.${lightIndex}.g1`" :rules="[{ required: true, message: '请输入光照强度', trigger: 'blur' }]">
                          <el-input-number v-model="lightRecord.g1" :min="0" :max="100000" size="small" style="width: 100%" placeholder="输入光照强度"></el-input-number>
                        </el-form-item>
                      </div>
                      <div class="light-record-actions">
                        <el-button type="danger" size="mini" @click="removeLightRecord(dayIndex, lightIndex)">删除</el-button>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="empty-light-records">
                  <p>暂无光照强度记录</p>
                </div>
              </div>
            </div>
            <div class="add-button-container">
              <el-button type="primary" size="small" @click="addOutdoorDayItem">添加新的一天记录</el-button>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-form>

    <span slot="footer" class="dialog-footer" style="display: flex; gap: 40px; justify-content: center;">
      <el-button type="primary" plain @click="clearFormData" style="margin: 0;">重置</el-button>
      <el-button type="primary" @click="handleSave" style="margin: 0;">保存</el-button>
      <el-button @click="handleClose" style="margin: 0;">关闭</el-button>
    </span>

    <el-dialog title="扫码识别" :visible.sync="scanDialogVisible" width="520px" append-to-body :close-on-click-modal="false" @closed="onScanDialogClosed">
      <div class="scan-container">
        <video ref="barcodeVideo" autoplay playsinline muted class="scan-video"></video>

        <div class="scan-toolbar">
          <el-select v-if="videoDevices.length > 0" v-model="selectedCameraId" placeholder="选择摄像头" size="mini" style="width: 100%;" @change="restartScanner">
            <el-option v-for="d in videoDevices" :key="d.deviceId" :label="d.label || ('摄像头' + d.deviceId.slice(0, 8))" :value="d.deviceId" />
          </el-select>

          <div style="display: flex; gap: 8px; width: 100%;">
            <el-button size="mini" type="primary" :icon="scanStarting ? 'el-icon-loading' : 'el-icon-video-play'" @click="startScanner" :disabled="scanStarting" plain>{{ scanStarting ? '启动中...' : '开始/重试' }}</el-button>
            <el-button size="mini" type="warning" icon="el-icon-switch-button" @click="stopScanner" plain>停止</el-button>
            <el-button size="mini" type="success" icon="el-icon-sunny" @click="toggleTorch" :disabled="!canTorch" plain>补光</el-button>
          </div>
        </div>

        <div v-if="scanResult" class="scan-result">
          识别结果：<span class="scan-result-text">{{ scanResult }}</span>
        </div>
        <div v-if="scanError" class="scan-error">{{ scanError }}</div>
        <div class="scan-tip">
          说明：电脑可用于调试；请在 <b>https://</b> 或 <b>http://localhost</b> 环境下，并允许摄像头权限。
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="closeScanDialog">关闭</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import axios from 'axios';
import { BrowserMultiFormatReader } from '@zxing/browser';

export default {
  name: 'DetailDialog',
  props: {
    visible: { type: Boolean, default: false },
    rowData: { type: Object, default: () => ({}) },
    tableBasicColumns: { type: Array, default: () => [] },
    tableBehaveColumns: { type: Array, default: () => [] },
    tableLightColumns: { type: Array, default: () => [] },
    tableOutdoorColumns: { type: Array, default: () => [] },
    tableWords: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      dialogVisible: false,
      activeName: 'baseInfo',
      formData: { e1: 0, e2: 0, e3: 0, e4: 0, e5: 0, e6: 0, e7: 0, e5Type: undefined, e5Time: undefined, e7Type: undefined },
      initialFormData: null, // 淇濆瓨鍒濆琛ㄥ崟鏁版嵁

      // ===== 鏂板锛氭潯鐮?& 鏌ヨ鐘舵€?=====
      barcodeText: '',
      queryLoading: false,
      queryError: '',

      // ===== 鎵爜鐩稿叧鐘舵€?=====
      scanDialogVisible: false,
      codeReader: null,
      videoDevices: [],
      selectedCameraId: null,
      canTorch: false,
      scanResult: '',
      scanError: '',
      scanStarting: false,
      torchOn: false,

    };
  },
  computed: {
    filteredTableBasicColumns() {
      if (!this.tableBasicColumns) return [];
      return this.tableBasicColumns;
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal;
      if (newVal) {
        this.formData = { e1: 0, e2: 0, e3: 0, e4: 0, e5: 0, e6: 0, e7: 0, e5Type: undefined, e5Time: undefined, e7Type: undefined };
        // 淇濆瓨鍒濆鐘舵€佺殑娣辨嫹璐?
        this.initialFormData = JSON.parse(JSON.stringify(this.formData));
      }
    },
    dialogVisible(newVal) {
      this.$emit('update:visible', newVal);
    },
    rowData: {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          this.formData = { ...newVal };
          this.formatFormDataForDisplay();
          for (let i = 1; i <= 7; i++) {
            if (typeof this.formData[`e${i}`] === 'undefined') {
              this.$set(this.formData, `e${i}`, 0);
            }
          }
          if (typeof this.formData.e5Type === 'undefined') {
            this.$set(this.formData, 'e5Type', undefined);
          }
          if (typeof this.formData.e5Time === 'undefined') {
            this.$set(this.formData, 'e5Time', undefined);
          }
          if (typeof this.formData.e7Type === 'undefined') {
            this.$set(this.formData, 'e7Type', undefined);
          }
          if (!this.formData.outdoor) {
            this.formData.outdoor = [];
          } else {
            this.formData.outdoor = this.formData.outdoor.map(dayItem => {
              if (!dayItem.lightRecords && (dayItem.hour_id !== undefined || dayItem.g1 !== undefined)) {
                return {
                  check_date: dayItem.check_date || '',
                  f1: dayItem.f1 || 0,
                  lightRecords: [{ hour_id: dayItem.hour_id || 0, g1: dayItem.g1 || 0 }]
                };
              } else if (!dayItem.lightRecords) {
                return { check_date: dayItem.check_date || '', f1: dayItem.f1 || 0, lightRecords: [] };
              }
              return dayItem;
            });
          }
          // 鍦ㄦ暟鎹鐞嗗畬鎴愬悗淇濆瓨鍒濆鐘舵€佺殑娣辨嫹璐?
          this.initialFormData = JSON.parse(JSON.stringify(this.formData));
        }
      },
      deep: true
    }
  },
  methods: {
    isReadOnlyBasicField(prop) {
      return [
        'user_id',
        'store',
        'optometrist',
        'patient_id',
        'patient_no',
        'examine_id',
        'check_date',
        'ai_first_analysis_date'
      ].includes(prop);
    },
    async fetchExamResultByBarcode(patient_no) {
      // 璋冪敤鍚庣API鑾峰彇骞惰浆鎹㈡暟鎹?
      const url = '/api/fetch_exam_data/';
      const payload = { patient_no };
      const { data } = await axios.post(url, payload, { timeout: 15000 });
      return data;
    },
    fillFormWithConvertedData(convertedData) {
      /**
       * 浣跨敤鍚庣杞崲濂界殑鏁版嵁鐩存帴濉厖琛ㄥ崟
       * 鍚庣宸茬粡瀹屾垚浜嗘墍鏈夌殑鏁版嵁杞崲鍜屾槧灏勫伐浣?
       */
      if (!convertedData) return;

      // 鍏堟竻绌鸿〃鍗曞埌鍒濆鐘舵€?
      this.clearFormDataSilently();

      // 閬嶅巻杞崲鍚庣殑鏁版嵁锛岀洿鎺ヨ祴鍊肩粰formData
      Object.keys(convertedData).forEach(key => {
        const value = convertedData[key];
        if (value !== undefined && value !== null && value !== '') {
          this.$set(this.formData, key, value);
        }
      });
      this.formatFormDataForDisplay();

      // 鐗规畩澶勭悊鏃ユ湡鏍煎紡
      if (convertedData.birth_date) {
        this.formData.birth_date = convertedData.birth_date;
      }
      if (convertedData.check_date) {
        this.formData.check_date = convertedData.check_date;
      }
      if (convertedData.pre_diagnose_time) {
        this.formData.pre_diagnose_time = convertedData.pre_diagnose_time;
      }
    },
    async handleQueryByBarcode() {
      if (!this.barcodeText) {
        this.$message.warning('请先输入条码或扫码');
        return;
      }
      try {
        this.queryError = '';
        this.queryLoading = true;
        const data = await this.fetchExamResultByBarcode(this.barcodeText);
        if (data?.status !== 'success') {
          const errorMessage = data?.message || '查询失败';
          this.queryError = errorMessage;
          this.$message.error(errorMessage);
          return;
        }
        const result = data?.data || {};
        if (!result || Object.keys(result).length === 0) {
          const warningMessage = '未查询到该条码对应的数据';
          this.queryError = warningMessage;
          this.$message.warning(warningMessage);
          return;
        }
        this.fillFormWithConvertedData(result);
        this.$message.success('查询成功，数据已回填');
      } catch (e) {
        console.error(e);
        let errorMessage = '查询失败';
        if (e?.response?.data?.message) {
          errorMessage = e.response.data.message;
        } else if (e?.message) {
          errorMessage = e.message;
        }
        this.queryError = errorMessage;
        this.$message.error(errorMessage);
      } finally {
        this.queryLoading = false;
      }
    },
    openScanDialog() {
      this.scanDialogVisible = true;
      this.scanResult = '';
      this.scanError = '';
      this.$nextTick(() => this.startScanner());
    },
    closeScanDialog() {
      this.stopScanner();
      this.scanDialogVisible = false;
    },
    onScanDialogClosed() {
      this.stopScanner();
    },
    async listCameras() {
      try {
        const tempStream = await navigator.mediaDevices.getUserMedia({ video: true });
        tempStream.getTracks().forEach(t => t.stop());
      } catch (e) {
        this.scanError = '无法访问摄像头：' + (e && e.message ? e.message : e);
      }
      try {
        this.videoDevices = await BrowserMultiFormatReader.listVideoInputDevices();
        if (!this.videoDevices || this.videoDevices.length === 0) {
          this.scanError = (this.scanError ? this.scanError + '；' : '') + '未检测到可用摄像头';
          this.selectedCameraId = null;
          return;
        }
        const back = this.videoDevices.find(d => /back|rear|environment/i.test(d.label));
        this.selectedCameraId = this.selectedCameraId || (back ? back.deviceId : this.videoDevices[0].deviceId);
      } catch (e) {
        this.scanError = '获取摄像头列表失败：' + (e && e.message ? e.message : e);
        this.selectedCameraId = null;
      }
    },
    async startScanner() {
      try {
        if (!this.codeReader) this.codeReader = new BrowserMultiFormatReader();
        this.scanStarting = true;
        await this.listCameras();

        const onResult = (result, err, controls) => {
          if (controls && controls.stream) {
            const track = controls.stream.getVideoTracks?.()[0];
            const caps = track?.getCapabilities?.();
            this.canTorch = !!(caps && caps.torch);
          }
          if (result) {
            const text = (result.getText && result.getText()) || result.text || String(result);
            this.onScanSuccess(text);
          }
          void err;
        };

        if (this.selectedCameraId) {
          await this.codeReader.decodeFromVideoDevice(this.selectedCameraId, this.$refs.barcodeVideo, onResult);
          return;
        }
        await this.codeReader.decodeFromConstraints(
          { video: { facingMode: { ideal: 'environment' }, width: { ideal: 1280 }, height: { ideal: 720 } } },
          this.$refs.barcodeVideo,
          onResult
        );
      } catch (e) {
        this.scanError = '启动扫码失败：' + (e && e.message ? e.message : e);
      } finally {
        this.scanStarting = false;
      }
    },
    async restartScanner() {
      this.stopScanner();
      this.scanResult = '';
      this.scanError = '';
      await this.startScanner();
    },
    stopScanner() {
      try {
        if (this.codeReader) this.codeReader.reset();
      } catch (e) {// eslint-disable-line no-empty
        }
    },
    async toggleTorch() {
      try {
        const videoEl = this.$refs.barcodeVideo;
        const track = videoEl?.srcObject?.getVideoTracks?.()[0];
        if (!track) return;
        const caps = track.getCapabilities?.();
        if (!(caps && caps.torch)) {
          this.$message.warning('当前摄像头不支持补光');
          return;
        }
        this.torchOn = !this.torchOn;
        await track.applyConstraints({ advanced: [{ torch: this.torchOn }] });
      } catch (e) {
        this.$message.error('补光设置失败');
      }
    },
    onScanSuccess(text) {
      this.scanResult = text;
      this.$message.success('识别成功：' + text);
      this.barcodeText = text;
      this.closeScanDialog();
      // ????????????????
      //this.handleQueryByBarcode();
    },
    formatFormDataForDisplay() {
      // 闇€瑕佹牸寮忓寲涓轰袱浣嶅皬鏁扮殑瀛楁
      const twoDecimalFields = ['a1', 'a2', 'a3', 'a4', 'a8', 'a9', 'a24', 'a25', 'a26'];
      // 闇€瑕佹牸寮忓寲涓轰竴浣嶅皬鏁扮殑瀛楁
      const oneDecimalFields = ['a16', 'a17', 'a27', 'a28', 'a29', 'a30', 'od_balanced_correct', 'os_balanced_correct'];
      // 闇€瑕佹牸寮忓寲涓烘璐熷彿鏁存暟鐨勫瓧娈?
      const signedIntFields = ['a10', 'a11'];
      
      // 鏍煎紡鍖栦袱浣嶅皬鏁板瓧娈?
      twoDecimalFields.forEach(field => {
        if (this.formData[field] !== null && this.formData[field] !== undefined && this.formData[field] !== '') {
          const num = parseFloat(this.formData[field]);
          if (!isNaN(num)) {
            this.formData[field] = num.toFixed(2);
          }
        }
      });
      
      // 鏍煎紡鍖栦竴浣嶅皬鏁板瓧娈?
      oneDecimalFields.forEach(field => {
        if (this.formData[field] !== null && this.formData[field] !== undefined && this.formData[field] !== '') {
          const num = parseFloat(this.formData[field]);
          if (!isNaN(num)) {
            this.formData[field] = num.toFixed(1);
          }
        }
      });
      
      // 鏍煎紡鍖栨璐熷彿鏁存暟瀛楁
      signedIntFields.forEach(field => {
        if (this.formData[field] !== null && this.formData[field] !== undefined && this.formData[field] !== '') {
          const num = parseFloat(this.formData[field]);
          if (!isNaN(num)) {
            const intNum = Math.round(num);
            this.formData[field] = intNum >= 0 ? `+${intNum}` : `${intNum}`;
          }
        }
      });
      
      // 澶勭悊鏄犲皠瀛楀吀 - 灏嗙储寮曞€艰浆鎹负瀵瑰簲鐨勬枃鏈樉绀猴紙浣嗕笉澶勭悊select瀛楁锛?
      for (const key in this.tableWords) {
        if (this.tableWords[key] && this.formData[key] !== null && this.formData[key] !== undefined) {
          const value = this.formData[key];
          // 濡傛灉鍊兼槸鏁板瓧绱㈠紩涓斿湪鑼冨洿鍐咃紝骞朵笖涓嶆槸select瀛楁锛屽垯杞崲涓哄搴旂殑鏂囨湰
          if (typeof value === 'number' && value >= 0 && value < this.tableWords[key].length && !this.isSelectField(key)) {
            this.formData[key] = this.tableWords[key][value];
          }
        }
      }
    },
    handleInputFocus(prop) {
      // 褰撹緭鍏ユ鑾峰緱鐒︾偣鏃讹紝灏嗘牸寮忓寲鐨勫€艰浆鎹㈠洖鍘熷鍊间互渚跨紪杈?
      this.convertToRawValue(prop);
    },
    handleInputBlur(prop) {
      // 褰撹緭鍏ユ澶卞幓鐒︾偣鏃讹紝閲嶆柊鏍煎紡鍖栨樉绀?
      this.formatSingleField(prop);
    },
    convertToRawValue(prop) {
      // 澶勭悊鏄犲皠瀛楀吀 - 灏嗘枃鏈€艰浆鎹㈠洖绱㈠紩鍊硷紙浣嗕笉澶勭悊select瀛楁锛?
      for (const key in this.tableWords) {
        if (key === prop && this.tableWords[key] && this.formData[key] !== null && this.formData[key] !== undefined && !this.isSelectField(key)) {
          const value = this.formData[key];
          // 濡傛灉鍊兼槸鏂囨湰锛屾壘鍒板搴旂殑绱㈠紩
          if (typeof value === 'string') {
            const index = this.tableWords[key].indexOf(value);
            if (index !== -1) {
              this.formData[key] = index;
            }
          }
        }
      }
    },
    formatSingleField(prop) {
      // 闇€瑕佹牸寮忓寲涓轰袱浣嶅皬鏁扮殑瀛楁
      const twoDecimalFields = ['a1', 'a2', 'a3', 'a4', 'a8', 'a9', 'a24', 'a25', 'a26'];
      // 闇€瑕佹牸寮忓寲涓轰竴浣嶅皬鏁扮殑瀛楁
      const oneDecimalFields = ['a16', 'a17', 'a27', 'a28', 'a29', 'a30', 'od_balanced_correct', 'os_balanced_correct'];
      // 闇€瑕佹牸寮忓寲涓烘璐熷彿鏁存暟鐨勫瓧娈?
      const signedIntFields = ['a10', 'a11'];
      
      if (this.formData[prop] !== null && this.formData[prop] !== undefined && this.formData[prop] !== '') {
        // 鏍煎紡鍖栦袱浣嶅皬鏁板瓧娈?
        if (twoDecimalFields.includes(prop)) {
          const num = parseFloat(this.formData[prop]);
          if (!isNaN(num)) {
            this.formData[prop] = num.toFixed(2);
          }
        }
        
        // 鏍煎紡鍖栦竴浣嶅皬鏁板瓧娈?
        if (oneDecimalFields.includes(prop)) {
          const num = parseFloat(this.formData[prop]);
          if (!isNaN(num)) {
            this.formData[prop] = num.toFixed(1);
          }
        }
        
        // 鏍煎紡鍖栨璐熷彿鏁存暟瀛楁
        if (signedIntFields.includes(prop)) {
          const num = parseFloat(this.formData[prop]);
          if (!isNaN(num)) {
            const intNum = Math.round(num);
            this.formData[prop] = intNum >= 0 ? `+${intNum}` : `${intNum}`;
          }
        }
      }
      
      // 澶勭悊鏄犲皠瀛楀吀 - 灏嗙储寮曞€艰浆鎹负瀵瑰簲鐨勬枃鏈樉绀猴紙浣嗕笉澶勭悊select瀛楁锛?
      for (const key in this.tableWords) {
        if (key === prop && this.tableWords[key] && this.formData[key] !== null && this.formData[key] !== undefined && !this.isSelectField(key)) {
          const value = this.formData[key];
          // 濡傛灉鍊兼槸鏁板瓧绱㈠紩涓斿湪鑼冨洿鍐咃紝杞崲涓哄搴旂殑鏂囨湰
          if (typeof value === 'number' && value >= 0 && value < this.tableWords[key].length) {
            this.formData[key] = this.tableWords[key][value];
          }
        }
      }
    },
    handleBasicFieldChange(prop) {
      // 保留空实现，方便后续继续挂接输入联动逻辑
      void prop;
    },
    isSelectField(prop) {
      return this.tableWords && this.tableWords[prop] && Array.isArray(this.tableWords[prop]);
    },
    getSelectOptions(prop) {
      if (this.isSelectField(prop)) {
        return this.tableWords[prop].filter(option => option !== '' && option !== null);
      }
      return [];
    },
    getSelectValue(prop, option, index) {
      if (prop === 'a23') {
        return option === null ? null : Number(option);
      }
      return index;
    },
    getFieldRules(prop) {
      // a3, a4, a5, a6, a7, a8, a9, a10鍒癮15涓嶆槸蹇呭～椤癸紝浠ュ強闂ㄥ簵銆侀獙鍏夊笀鍜屾鏌ユ棩鏈熶篃涓嶆槸蹇呭～椤癸紙鍙瀛楁锛?
      const numericFields = ['a1', 'a2', 'a3', 'a4', 'a7', 'a8', 'a9', 'a10', 'a11', 'a16', 'a17', 'a24', 'a25', 'a26', 'a27', 'a28', 'a29', 'a30', 'od_balanced_correct', 'os_balanced_correct'];
      const eyeFields = ['a5', 'a6', 'a18', 'a19', 'a20', 'a21'];
      // const optionalFields = ['user_id', 'store', 'optometrist', 'patient_id', 'patient_no', 'examine_id', 'check_date', ...numericFields];
      
      const rules = [];

      // // 蹇呭～鏍￠獙
      // if (!optionalFields.includes(prop)) {
      //   rules.push({ required: true, message: `璇疯緭鍏?{this.getColumnLabel(prop)}`, trigger: 'blur' });
      // }

      // 鏁板瓧鏍煎紡鏍￠獙
      if (numericFields.includes(prop)) {
        rules.push({
          validator: (rule, value, callback) => {
            if (value === '' || value === null || value === undefined) {
              callback();
            } else if (isNaN(Number(value))) {
              callback(new Error('璇疯緭鍏ユ湁鏁堢殑鏁板瓧'));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        });
      }

      // eyeFields 鏍煎紡鏍￠獙
      if (eyeFields.includes(prop)) {
        rules.push({
          validator: (rule, value, callback) => {
            if (value === '' || value === null || value === undefined) {
              callback();
              return;
            }
            // Format 1: +x, -x, or x (two decimals)
            // Format 2: +x/+y or x/y (two decimals)
            // Format 3: cylinder 0.00 is allowed, signs are optional
            // Format 4: +x/+y*z--p/q style suffix is still supported
            const pattern = /^[+-]?\d+\.\d{2}(\/[+-]?\d+\.\d{2}(\*\d+(--\d+\.\d{1}\/\d+\.\d{1})?)?)?$/;
            
            if (pattern.test(value)) {
              callback();
            } else {
              callback(new Error('Format examples: +1.00/-2.00*90, -0.25/0.00*180, 0.50/0.00*90'));
            }
          },
          trigger: 'blur'
        });
      }

      return rules;
    },
    getColumnLabel(prop) {
      const column = this.filteredTableBasicColumns.find(col => col.prop === prop);
      return column ? column.label : prop;
    },
    handleNoneChange() {
      if (Array.isArray(this.formData.e1)) {
        if (this.formData.e1.includes('无')) {
          this.formData.e1 = ['无'];
        } else {
          this.formData.e1 = this.formData.e1.filter(item => item !== '无');
        }
      }
    },
    handleCheckboxChange() {
      // 鍙鏈変换鎰廻1~h5琚€変腑锛宧6锛堟棤锛夊氨瑕佸彇娑?
      if (this.formData.e1 || this.formData.e2 || this.formData.e3 || this.formData.e4 || this.formData.e5 || this.formData.e7) {
        this.formData.e6 = 0;
      }
      // 妗嗘灦鐪奸暅鏈€変腑鏃讹紝娓呯┖绫诲瀷
      if (this.formData.e5 !== 1) {
        this.formData.e5Type = undefined;
        this.formData.e5Time = undefined;
      }
      if (this.formData.e7 !== 1) {
        this.formData.e7Type = undefined;
      }
    },
    handleNoneCheckboxChange() {
      // 閫変腑鈥滄棤鈥濇椂锛屽叾浠栧叏閮ㄥ彇娑?
      if (this.formData.e6 === 1) {
        this.formData.e1 = 0;
        this.formData.e2 = 0;
        this.formData.e3 = 0;
        this.formData.e4 = 0;
        this.formData.e5 = 0;
        this.formData.e5Type = undefined;
        this.formData.e5Time = undefined;
        this.formData.e7 = 0;
        this.formData.e7Type = undefined;
      }
    },
    handleClose() {
      this.dialogVisible = false;
      this.$emit('close');
    },
    handleSave() {
      this.$refs.detailForm.validate(valid => {
        if (!valid) {
          this.$message.error('请完善所有必填项');
          return;
        }

        const dataToSave = { ...this.formData };
        delete dataToSave.ai_first_analysis_date;

        Object.keys(dataToSave).forEach(key => {
          if (key.startsWith('a') && dataToSave[key] === '') {
            dataToSave[key] = null;
          }
        });

        for (let i = 1; i <= 7; i++) {
          const key = `e${i}`;
          dataToSave[key] = Number(this.formData[key]) || 0;
        }

        if (this.formData.e5Type === undefined) {
          delete dataToSave.e5Type;
        }
        if (this.formData.e5Time === undefined) {
          delete dataToSave.e5Time;
        }
        if (this.formData.e7Type === undefined) {
          delete dataToSave.e7Type;
        }
        if (this.formData.outdoor) {
          dataToSave.outdoor = dataToSave.outdoor.map(dayItem => {
            return {
              check_date: dayItem.check_date || '',
              f1: Number(dayItem.f1) || 0,
              lightRecords: (dayItem.lightRecords || []).map(record => ({
                hour_id: Number(record.hour_id) || 0,
                g1: Number(record.g1) || 0
              }))
            };
          });
        }
        console.log('Saving form data:', dataToSave);

        this.$emit('save', dataToSave, success => {
          if (success) {
            this.handleClose();
          }
        });
      });
    },
    addOutdoorItem() {
      if (!this.formData.outdoor) {
        this.$set(this.formData, 'outdoor', []);
      }
      const newItem = {};
      this.tableOutdoorColumns.forEach(column => {
        newItem[column.prop] = '';
      });
      this.formData.outdoor.push(newItem);
    },
    removeOutdoorItem(index) {
      if (this.formData.outdoor && this.formData.outdoor.length > index) {
        this.formData.outdoor.splice(index, 1);
      }
    },
    // 鏂扮殑鎴峰娲诲姩绠＄悊鏂规硶
    addOutdoorDayItem() {
      if (!this.formData.outdoor) {
        this.$set(this.formData, 'outdoor', []);
      }
      const newDayItem = {
        check_date: '',
        f1: 0, // 鎴峰娲诲姩鏃堕暱锛堝垎閽燂級
        lightRecords: [] // 鍏夌収寮哄害璁板綍鏁扮粍
      };
      this.formData.outdoor.push(newDayItem);
    },
    removeOutdoorDayItem(dayIndex) {
      if (this.formData.outdoor && this.formData.outdoor.length > dayIndex) {
        this.formData.outdoor.splice(dayIndex, 1);
      }
    },
    addLightRecord(dayIndex) {
      if (!this.formData.outdoor[dayIndex].lightRecords) {
        this.$set(this.formData.outdoor[dayIndex], 'lightRecords', []);
      }
      const newLightRecord = {
        hour_id: 0, // 鏃堕棿娈碉紙0-23锛?
        g1: 0 // 鍏夌収寮哄害锛坙x锛?
      };
      this.formData.outdoor[dayIndex].lightRecords.push(newLightRecord);
    },
    removeLightRecord(dayIndex, lightIndex) {
      if (this.formData.outdoor[dayIndex].lightRecords && 
          this.formData.outdoor[dayIndex].lightRecords.length > lightIndex) {
        this.formData.outdoor[dayIndex].lightRecords.splice(lightIndex, 1);
      }
    },
    clearFormData() {
      this.$confirm('确定要清空当前表单数据吗？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.clearFormDataSilently();
        this.$message.success('表单数据已清空');
      }).catch(() => {
        // ??????
      });
    },
    clearFormDataSilently() {
      // 闈欓粯娓呯┖琛ㄥ崟鏁版嵁锛屼笉鏄剧ず纭瀵硅瘽妗嗗拰鎴愬姛鎻愮ず
      if (this.initialFormData) {
        // 鎭㈠鍒板垵濮嬬姸鎬佺殑娣辨嫹璐?
        this.formData = JSON.parse(JSON.stringify(this.initialFormData));
      } else {
        // 濡傛灉娌℃湁鍒濆鏁版嵁锛岃缃负榛樿鍊?
        this.formData = { e1: 0, e2: 0, e3: 0, e4: 0, e5: 0, e6: 0, e7: 0, e5Type: undefined, e5Time: undefined, e7Type: undefined };
      }
      
      // 娓呯┖鏉＄爜鐩稿叧鐘舵€?
      this.barcodeText = '';
      this.queryError = '';
      
      // 鍒囨崲鍒板熀鏈俊鎭痶ab
      this.activeName = 'baseInfo';
      
      // 娓呴櫎琛ㄥ崟楠岃瘉閿欒
      this.$nextTick(() => {
        if (this.$refs.detailForm) {
          this.$refs.detailForm.clearValidate();
        }
      });
    },
  }
};
</script>

<style scoped>
.detail-form { max-height: 75vh; overflow-y: auto; }

/* 鏉＄爜鍗曠嫭涓€琛?*/
.barcode-line { display: flex; width: 100%; margin-bottom: 10px; }
.barcode-item { margin-bottom: 10px !important; }
.query-error { color: #F56C6C; margin-left: 12px; }

.form-fields-wrapper { display: flex; flex-wrap: wrap; justify-content: space-between; gap: 15px 5px; }
.form-fields-box { display: flex; flex-wrap: wrap; justify-content: space-between; gap: 5px 10px; }
.form-field-item { min-width: 200px; }
.form-box-item { min-width: 450px; }
::v-deep .el-form-item { margin-bottom: 0; }
::v-deep .el-form-item__label { font-size: 14px; color: #606266; }
::v-deep .el-input--small .el-input__inner { font-size: 14px; }
.dialog-footer { text-align: right; }
.dialog-footer .el-button { margin-left: 10px; }
::v-deep .el-dialog__header { padding: 10px 0; }
::v-deep .el-dialog { margin-top: 5vh !important; }
::v-deep .el-dialog__body { padding: 0 0 0 20px; }
::v-deep .el-dialog__headerbtn { top: 10px; right: 10px; }

.array-form-section { width: 100%; }
.array-item { border: 1px solid #EBEEF5; border-radius: 4px; padding: 15px; background-color: #FAFAFA; }
.array-item-header { display: flex; justify-content: space-between; align-items: center; padding-bottom: 10px; border-bottom: 1px solid #E4E7ED; }
.array-item-header h4 { margin: 0; font-size: 16px; color: #303133; font-weight: 500; }
.add-button-container { text-align: center; margin-top: 20px; padding: 15px; border: 2px dashed #DCDFE6; border-radius: 4px; background-color: #FAFAFA; }
.add-button-container:hover { border-color: #409EFF; background-color: #F0F9FF; }
.day-basic-info { display: flex; gap: 10px; padding: 10px; background-color: #F8F9FA; border-radius: 4px; }
.light-intensity-section { border-top: 1px solid #E4E7ED; padding-top: 15px; }
.light-section-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 15px; }
.light-section-header h5 { margin: 0; font-size: 14px; color: #303133; font-weight: 500; }
.light-records { display: flex; flex-direction: column; }
.light-record-item { border: 1px solid #E4E7ED; border-radius: 4px; padding: 0 10px; background-color: #FFFFFF; }
.light-record-content { display: flex; align-items: center; gap: 15px; }
.light-record-actions { margin-left: auto; }
.empty-light-records { text-align: center; padding: 20px; color: #909399; font-style: italic; }
.empty-light-records p { margin: 0; }

.custom-max-width-dialog { max-width: 1920px; margin: 0 auto; }
/* 鎵爜寮圭獥鏍峰紡 */
.scan-container { display: flex; flex-direction: column; gap: 10px; }
.scan-video { width: 100%; max-height: 300px; background: #000; border-radius: 6px; }
.scan-toolbar { display: flex; flex-direction: column; gap: 8px; }
.scan-result { color: #67C23A; font-weight: 600; }
.scan-result-text { word-break: break-all; }
.scan-error { color: #F56C6C; }
.scan-tip { color: #909399; font-size: 12px; }
</style>
